import { Link } from "react-router-dom";
import { ArrowRight, Check, FileDown } from "lucide-react";
import { Seo } from "@/components/Seo";
import { COURSES, PRICING } from "@/data/courses";

const leadership = COURSES.find((course) => course.key === "Leadership");
const price = PRICING.Leadership;

const OUTCOMES = [
  "Communicate with clarity and confidence",
  "Make practical decisions under pressure",
  "Build trust, accountability, and stronger teams",
  "Lead with integrity in a changing workplace",
];

export default function LeadershipPage() {
  return (
    <main data-testid="page-leadership" className="bg-[#050505] pt-36 pb-24 md:pt-40">
      <Seo
        title="Leadership Training — Delta DL Enterprise, LLC"
        description="A 4-week online Leadership Training course with Dr. Dennis Louden for professionals, educators, students, and emerging leaders. $149."
        path="/leadership-training"
      />

      <section className="mx-auto max-w-[1500px] px-6 md:px-12">
        <span className="text-xs uppercase tracking-[0.4em] text-[#7C3AED]">
          Professional Development
        </span>
        <h1 className="mt-5 font-display text-6xl md:text-8xl uppercase tracking-tight text-white">
          Leadership Training
        </h1>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href="/leadership-training-course-pack.pdf"
            download
            data-testid="leadership-download-pdf-btn"
            className="magnetic-btn inline-flex items-center justify-center gap-2 rounded-full bg-[#7C3AED] px-6 py-3 text-xs font-semibold uppercase tracking-widest text-white transition-colors hover:bg-white hover:text-black"
          >
            <FileDown size={15} />
            Download Course Pack
          </a>
          <a
            href="/leadership-training-course-pack.docx"
            download
            data-testid="leadership-download-docx-btn"
            className="magnetic-btn inline-flex items-center justify-center gap-2 rounded-full border border-[#7C3AED]/60 bg-[#7C3AED]/10 px-6 py-3 text-xs font-semibold uppercase tracking-widest text-white transition-colors hover:bg-[#7C3AED] hover:text-white"
          >
            <FileDown size={15} />
            Editable Forms
          </a>
        </div>

        <p className="mt-6 max-w-3xl text-lg leading-relaxed text-white/65">
          {leadership.blurb}
        </p>

        <div className="mt-14 grid gap-8 lg:grid-cols-[1.15fr_0.85fr]">
          <div className="overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03]">
            <img
              src={leadership.image}
              alt="Leadership training discussion"
              data-testid="leadership-hero-image"
              className="h-[320px] w-full object-cover md:h-[520px]"
            />
          </div>

          <div className="rounded-2xl border border-[#7C3AED]/30 bg-white/[0.04] p-8 md:p-10">
            <span className="text-[10px] uppercase tracking-[0.3em] text-[#A78BFA]">
              4-Week Online Course
            </span>
            <div data-testid="leadership-price" className="mt-4 font-display text-6xl text-white">
              {price.price}
            </div>
            <p className="mt-2 text-sm uppercase tracking-[0.22em] text-white/45">
              {price.note}
            </p>

            <div className="mt-8 space-y-4">
              {OUTCOMES.map((outcome) => (
                <div key={outcome} className="flex items-start gap-3" data-testid="leadership-outcome">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#7C3AED]/20 text-[#A78BFA]">
                    <Check size={13} />
                  </span>
                  <span className="text-sm leading-relaxed text-white/70">{outcome}</span>
                </div>
              ))}
            </div>

            <Link
              to="/enroll?course=Leadership"
              data-testid="leadership-apply-btn"
              className="magnetic-btn mt-10 inline-flex items-center gap-2 rounded-full bg-[#7C3AED] px-7 py-3 text-sm font-semibold uppercase tracking-widest text-white transition-colors hover:bg-white hover:text-black"
            >
              Apply for Leadership Training
              <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
